'use client';

import { Drawer, DrawerContent, DrawerTitle, DrawerTrigger } from '@/components/ui/drawer';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

const ProductShareWith = ({ product, type }) => {
  const { locale } = useIntl();
  const [origin, setOrigin] = useState('');

  useEffect(() => {
    setOrigin(globalThis.location.origin);
  }, []);
  const currency = product.price?.regularPrice?.amount?.currency;
  const value = product.price?.regularPrice?.amount?.value;
  const [showDrawer, setShowDrawer] = useState(false);

  const currentPrice =
    currency && value
      ? new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
        }).format(value)
      : '';

  const links = (
    <>
      <a
        href={
          'http://www.facebook.com/sharer.php?u=' +
          origin +
          process.env.NEXT_PUBLIC_BASE_PATH +
          '/' +
          product.url_key +
          '.html'
        }
        className='group flex h-[25px] w-[25px] items-center justify-center'
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='11'
          height='21'
          fill='none'
          viewBox='0 0 11 21'
        >
          <g clipPath='url(#clip0_18304_7140)'>
            <path
              className='fill-80583F lg_group-hover_fill-[#5E5047]'
              d='M10.12 11.192H6.65v9.4h-3.6v-9.4H.55v-3.4h2.5v-2.9c0-2.3 1.5-4.4 4.8-4.4 1.4 0 2.4.1 2.4.1l-.13 3.2H8.05c-1.2 0-1.4.5-1.4 1.5v2.5h3.7z'
            ></path>
          </g>
          <defs>
            <clipPath id='clip0_18304_7140'>
              <path
                fill='#fff'
                d='M.55.492h9.8v20.1H.55z'
              ></path>
            </clipPath>
          </defs>
        </svg>
      </a>
      <a
        href={
          'http://pinterest.com/pin/create/button/?url=' +
          origin +
          process.env.NEXT_PUBLIC_BASE_PATH +
          '/' +
          product.url_key +
          '.html&media=' +
          origin +
          process.env.NEXT_PUBLIC_BASE_PATH +
          'media/catalog/product/' +
          product?.media_gallery_entries[0]?.file +
          '&description=' +
          product.name +
          currentPrice
        }
        className='group flex h-[25px] w-[25px] items-center justify-center'
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='18'
          height='22'
          fill='none'
          viewBox='0 0 18 22'
        >
          <g clipPath='url(#clip0_18304_7145)'>
            <path
              className='fill-80583F lg_group-hover_fill-[#5E5047]'
              d='M3.942 20c-.03-.97.03-1.94.2-2.9.2-1 1.6-6.9 1.6-6.9-.28-.63-.41-1.31-.4-2 0-1.9 1.1-3.3 2.4-3.3.93-.02 1.69.72 1.71 1.65v.25a25 25 0 0 1-1.1 4.5c-.22 1.08.48 2.14 1.56 2.36.15.02.29.02.44 0 2.4 0 4-3.1 4-6.7 0-2.8-1.9-4.9-5.3-4.9-3.31-.11-6.09 2.48-6.2 5.79v.31c-.05.9.24 1.79.8 2.5.2.3.3.4.2.7s-.2.8-.3 1c-.04.23-.26.38-.49.34h-.11c-1.8-.7-2.6-2.7-2.6-4.8 0-3.6 3-7.9 9.1-7.9 4.8 0 8 3.5 8 7.3 0 5-2.8 8.7-6.8 8.7-1.25.07-2.44-.54-3.1-1.6 0 0-.7 2.9-.9 3.5-.29.96-.73 1.87-1.3 2.7.09 0-1.11 1.4-1.41-.6'
            ></path>
          </g>
          <defs>
            <clipPath id='clip0_18304_7145'>
              <path
                fill='#fff'
                d='M.352 0h17.1v21.08H.352z'
              ></path>
            </clipPath>
          </defs>
        </svg>
      </a>
      <a
        href={
          'mailto:?subject=AW Bridal Real Wedding!&body=' +
          product.name +
          ' ' +
          currentPrice +
          '; ' +
          origin +
          process.env.NEXT_PUBLIC_BASE_PATH +
          '/' +
          product.url_key +
          '.html'
        }
        className='group flex h-[25px] w-[25px] items-center justify-center'
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='23'
          height='15'
          fill='none'
          viewBox='0 0 23 15'
        >
          <g clipPath='url(#clip0_18304_7150)'>
            <path
              className='fill-80583F lg_group-hover_fill-[#5E5047]'
              d='M20.951.29h-18.7c-.98-.01-1.79.78-1.8 1.76v10.94c-.01.99.79 1.79 1.78 1.8h18.72c.99.01 1.79-.79 1.8-1.78V1.99c-.11-.93-.87-1.65-1.8-1.7m-7.4 6.6-1.9 1.5-1.9-1.5-6.6-5.1h17.1zm-5.6.6-6 4.5v-9.1zm1.3.9 2.4 1.8 2.4-1.8 6.27 4.8H2.951zm6-.9 6-4.5v9.1z'
            ></path>
          </g>
          <defs>
            <clipPath id='clip0_18304_7150'>
              <path
                fill='#fff'
                d='M.451.29h22.3v14.5H.451z'
              ></path>
            </clipPath>
          </defs>
        </svg>
      </a>
      <a
        href={
          'http://twitter.com/share?url=' + origin + process.env.NEXT_PUBLIC_BASE_PATH + '/' + product.url_key + '.html'
        }
        className='group flex h-[25px] w-[25px] items-center justify-center'
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='15'
          height='18'
          fill='none'
          viewBox='0 0 15 18'
        >
          <g clipPath='url(#clip0_9157_39098)'>
            <path
              className='fill-80583F lg_group-hover_fill-[#5E5047]'
              d='M.564 16.916q.554-.762 1.113-1.521 1.936-2.637 3.883-5.264c.137-.184.138-.312.021-.509C3.951 6.867 2.33 4.106.706 1.346.65 1.254.605 1.154.533 1.017c.13-.007.21-.016.291-.016 1.14 0 2.28.005 3.42-.005.18-.001.287.058.39.235 1.038 1.784 2.085 3.562 3.13 5.34.17.29.197.29.402.012 1.32-1.793 2.643-3.584 3.957-5.384.112-.153.221-.208.386-.201.29.012.582.003.943.003-.213.294-.379.525-.547.753-1.403 1.905-2.802 3.814-4.215 5.71-.183.244-.17.4-.02.651 1.673 2.828 3.336 5.663 5.002 8.497.06.102.116.208.195.35-.107.013-.17.028-.232.028-1.174.001-2.348-.003-3.521.006-.155.001-.244-.058-.328-.202Q8.116 13.94 6.44 11.09c-.17-.29-.196-.294-.4-.017-1.401 1.906-2.804 3.812-4.201 5.724-.103.14-.203.206-.362.198-.293-.014-.587-.004-.88-.004q-.017-.036-.033-.074m11.695-.921c-.095-.174-.14-.267-.193-.354L6.981 7.144C6.02 5.54 5.062 3.93 4.092 2.331c-.081-.134-.239-.276-.369-.286-.454-.035-.91-.015-1.366-.012-.053 0-.105.032-.192.061.068.127.117.226.173.32 2.564 4.285 5.137 8.563 7.679 12.866.319.539.633.82 1.2.724.318-.054.649-.01 1.042-.01'
            ></path>
          </g>
          <defs>
            <clipPath id='clip0_9157_39098'>
              <path
                fill='#fff'
                d='M.2.04h14v17H.2z'
              ></path>
            </clipPath>
          </defs>
        </svg>
      </a>
    </>
  );

  if (type === 'mobile') {
    return (
      <Drawer
        open={showDrawer}
        onOpenChange={setShowDrawer}
        direction='bottom'
        handleOnly
      >
        <DrawerTrigger asChild>
          <button
            type='button'
            className='absolute right-2.5 top-[15px]'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='21'
              fill='none'
              viewBox='0 0 20 21'
            >
              <g clipPath='url(#clip0_18304_27468)'>
                <path
                  fill='#80583F'
                  d='m19.82 4.241-3.67-4a.637.637 0 0 0-1 0 .76.76 0 0 0 0 1l2.1 2.27c-4.79-.1-9.19 3.53-10.72 8.49l1.29.73c1.35-4.42 5.86-8.13 10.18-7.6l-2.81 3c-.24.29-.24.71 0 1 .22.27.63.31.9.09l.01-.01.09-.08 3.55-3.85.11-.07c.21-.29.2-.69-.03-.97m-1.6 13.49c-.02.66-.56 1.18-1.22 1.17H2.47c-.66.01-1.2-.51-1.21-1.17v-14c.01-.66.55-1.18 1.21-1.17h6.06v-1.16H1.26c-.65-.02-1.19.5-1.21 1.15v16.35c.01.65.55 1.17 1.2 1.16h17.01c.65.01 1.19-.51 1.21-1.16v-7h-1.24z'
                ></path>
              </g>
              <defs>
                <clipPath id='clip0_18304_27468'>
                  <path
                    fill='#fff'
                    d='M.05 0H20v20.06H.05z'
                  ></path>
                </clipPath>
              </defs>
            </svg>
          </button>
        </DrawerTrigger>
        <DrawerContent className='fixed bottom-0 left-0 z-[400] h-auto w-full bg-white'>
          <DrawerTitle className='hidden' />
          <div className='flex items-center justify-between border-b-1 border-solid border-E7DED5 px-2.5 py-5'>
            <span className='font-Shango text-[18px]'>SHARE</span>
            <button
              type='button'
              onClick={() => {
                setShowDrawer(false);
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                fill='none'
                viewBox='0 0 18 18'
              >
                <path
                  stroke='#80583F'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='1.5'
                  d='M17 17 1 1m16 0L1 17'
                ></path>
              </svg>
            </button>
          </div>
          <div className='flex items-center justify-center gap-x-10 pb-[30px] pt-6'>{links}</div>
        </DrawerContent>
      </Drawer>
    );
  }

  if (type === 'desktop') {
    return (
      <div className='mt-2.5 flex items-center justify-center gap-x-3'>
        <span>Share With:</span>
        {links}
      </div>
    );
  }

  return null;
};

export default ProductShareWith;
